import styles from "./style.module.scss";
import classNames from "classnames";
import { EDatasetStatus } from "types";
import { Tooltip } from "antd";
import { DATASET_STATUS_TOOLTIP } from "helpers/constants/datasetStatusTooltips";

interface DatasetStatusButtonProps {
  status: EDatasetStatus;
  buttonStyle?: any;
}
export default function DatasetStatusButton({
  status,
  buttonStyle,
}: DatasetStatusButtonProps) {
  const getStyleByDatasetStatus: Record<EDatasetStatus, string> = {
    [EDatasetStatus.READY]: styles.greenButton,
    [EDatasetStatus.DRAFT]: styles.greyButton,
    [EDatasetStatus.INDEXING]: styles.blueButton,
    [EDatasetStatus.READ_ONLY]: styles.blueButton,
    [EDatasetStatus.PARTIAL_INDEX]: styles.orangeButton,
    [EDatasetStatus.ERROR]: styles.failed,
  };

  const displaySpinnerByDatasetStatus: Record<EDatasetStatus, boolean> = {
    [EDatasetStatus.READY]: false,
    [EDatasetStatus.DRAFT]: false,
    [EDatasetStatus.INDEXING]: true,
    [EDatasetStatus.READ_ONLY]: true,
    [EDatasetStatus.PARTIAL_INDEX]: false,
    [EDatasetStatus.ERROR]: false,
  };

  const inProgress = displaySpinnerByDatasetStatus[status];

  // Dynamic styling logic from deprecated version
  const handleButtonStyle = () => {
    const lineHeight = buttonStyle?.lineHeight
      ? parseFloat(buttonStyle.lineHeight)
      : null;

    if (!lineHeight) return buttonStyle;

    const paddingV = lineHeight * 0.5;
    const paddingH = lineHeight;

    return {
      ...buttonStyle,
      padding: `${paddingV}px ${paddingH}px`,
      borderRadius: `${paddingV}px`,
    };
  };

  const fontSize = handleButtonStyle()?.fontSize || undefined;
  const spinnerStyles = fontSize
    ? { height: fontSize, width: fontSize }
    : undefined;

  return (
    <Tooltip title={DATASET_STATUS_TOOLTIP[status]} mouseEnterDelay={0.4}>
      <div
        className={classNames(styles.default, getStyleByDatasetStatus[status])}
        style={handleButtonStyle()}
      >
        {inProgress && (
          <div className={styles.spinner} style={spinnerStyles}></div>
        )}
        {inProgress ? `${status}...` : status}
      </div>
    </Tooltip>
  );
}
